@reference "@glow/tailwind-config/reference.css";

.banner {
  @apply relative;
  @apply py-4;
  @apply pl-6;
  @apply pr-16;
  @apply top-0;
  @apply left-0;
  @apply w-full;
}

.banner.WARNING {
  @apply text-warning-dark;
  @apply bg-warning-light;
}

.banner.ERROR {
  @apply bg-danger-light;
  @apply text-danger-dark;
}

.banner.NEUTRAL {
  @apply bg-gray-200;
  @apply text-emphasis-high;
}

.text {
  @apply text-center;
  @apply px-4;
  @apply w-full;
  @apply text-base;
  @apply font-semibold;
}

.closeLink {
  @apply text-base;
  @apply absolute;
  @apply top-3;
  @apply right-4;
  @apply border-none;
}
